// Server-only subpath. Importing this in a Next route handler / Server
// Component / middleware does NOT pull HandoffLanding, PrepEmbed, or any
// of the React Context plumbing those rely on, so Next 15's "Collecting
// page data" step can load it without tripping
//   TypeError: (0 , s.createContext) is not a function
// (the trap that ./sharing falls into when imported from a server file).
//
// Client consumers of HandoffLanding / PrepEmbed should keep importing
// from "@benbraide/auth-service-nextjs/sharing" — that bundle still
// contains the client React components.
export { consumeHandoffToken } from './consumeHandoffToken';
export { createHandoffRouteHandler } from './createHandoffRouteHandler';
export type { CreateHandoffRouteHandlerOptions } from './createHandoffRouteHandler';
export {
  multiAccountAutoAdd,
  MultiAccountAutoAddError,
} from './multiAccountAutoAdd';
export type {
  MultiAccountAutoAddOptions,
  SwitcherApi,
} from './multiAccountAutoAdd';
export type {
  HandoffResult,
  HandoffSuccess,
  HandoffFailure,
  HandoffFailureReason,
  HandoffUser,
  ConsumeHandoffTokenOptions,
} from './types';
